import { render, staticRenderFns } from "./tagFieldsConfig.vue?vue&type=template&id=73bd4e9a&scoped=true"
import script from "./tagFieldsConfig.vue?vue&type=script&lang=js"
export * from "./tagFieldsConfig.vue?vue&type=script&lang=js"
import style0 from "./tagFieldsConfig.vue?vue&type=style&index=0&id=73bd4e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd4e9a",
  null
  
)

export default component.exports